import { Box, Heading, useToast, VStack } from "@chakra-ui/react";
import { Host } from "@olagg/db-types";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "../../consts/routes";
import HostForm from "./components/HostForm";
import useHosts from "./hooks/useHosts";

const UpdateHost = () => {
    const { updateHost, getHost } = useHosts();
    const { id } = useParams<{ id: string }>();
    const [host, setHost] = useState<Host | null>(null);
    const toast = useToast();
    const navigate = useNavigate();

    const onSubmit = (data: Partial<Host>) => {
        updateHost(id!, data)
            .then(() => {
                toast({
                    title: 'Host',
                    colorScheme: 'olaggPink',
                    status: 'success',
                    description: `Host actualizado con éxito`,
                    position: 'bottom-right'
                });
                navigate(ROUTES.EVENTS.all);
                setTimeout(() => {
                    window.location.reload();
                }, 100);
            })
            .catch((error: Error) => {
                toast({
                    title: 'Error',
                    colorScheme: 'olaggYellow',
                    status: 'error',
                    description: error.message,
                    position: 'bottom-right'
                });
            })
    }

    useEffect(() => {
        if (id) {
            getHost(id).then((response) => setHost(response.host))
        }
    }, [id]);

    if (!host) {
        return <Box>Loading...</Box>;
    }

    return (
        <Box w={'full'} pb={4} minH='600px'>
            <VStack color={'white'} w={'full'}>
                <Heading my={2}>Crear host</Heading>
                <HostForm onSubmit={onSubmit} host={host} />
            </VStack>
        </Box>
    )
};

export default UpdateHost;